import type { AnalyticEventName } from './analytics';
import { BroadcastChannel } from 'broadcast-channel';
import { Json } from 'types/index';
import { PageTypes } from 'utils/pageTypes';

type Target = {
  type: PageTypes;
  windowId?: string;
};

type Message =
  | {
      type: 'addContext';
      target: Target;
      key: string;
      value: Json;
    }
  | {
      type: 'addViewContext';
      target: Target;
      key: string;
      value: Json;
    }
  | {
      type: 'track';
      target: Target;
      name: AnalyticEventName;
      data?: Json;
    };

export const channel: BroadcastChannel<Message> = new BroadcastChannel('worker-analytics-channel');

export const workerAnalytics = {
  addViewContext: (target: Target, key: string, value: Json) => {
    channel.postMessage({ type: 'addViewContext', target, key, value });
  },
  addContext: (target: Target, key: string, value: Json) => {
    channel.postMessage({ type: 'addContext', target, key, value });
  },
  track: (target: Target, name: AnalyticEventName, data?: Json) => {
    channel.postMessage({ type: 'track', target, name, data });
  },
} as const;
